const BLOG_ENDPOINTS = {
  GET_BLOGS: '/public/blogs',
  GET_BLOG_DETAIL: '/public/blogs',          // + /:slug
  GET_BLOG_CATEGORIES: '/public/blog-categories',
  BLOG_COMMENTS: '/public/blogs',            // + /:slug/comments
  BLOG_COMMENT_REPLY: '/public/blog-comments', // + /:commentId/reply
  BLOG_NEWSLETTER_SUBSCRIBE: '/public/blog-newsletter/subscribe',
  BLOG_NEWSLETTER_UNSUBSCRIBE: '/public/blog-newsletter/unsubscribe',
  // One-click unsubscribe link from a campaign email — + /:token
  EMAIL_TRACK_UNSUBSCRIBE: '/public/email-track/unsubscribe',
};

export default BLOG_ENDPOINTS;
